import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import HomeScreen from './components/HomeScreen';
import Screener from './components/Screener';
import Results from './components/Results';
import AboutModal from './components/AboutModal';

function App() {
  const [currentScreen, setCurrentScreen] = useState('home');
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [answers, setAnswers] = useState({});
  const [resultPhase, setResultPhase] = useState('');

  const handleStartScreener = () => {
    setCurrentScreen('screener');
  };

  const handleShowResults = (phase) => {
    setResultPhase(phase);
    setCurrentScreen('results');
  };

  const handleResetScreener = () => {
    setCurrentScreen('home');
    setAnswers({});
    setResultPhase('');
  };

  const handleShowAbout = () => {
    setShowAboutModal(true);
  };

  const handleCloseAbout = () => {
    setShowAboutModal(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-sage-light via-white to-brand-peach-light font-poppins">
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
          <AnimatePresence mode="wait">
            {currentScreen === 'home' && (
              <motion.div
                key="home"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <HomeScreen 
                  onStart={handleStartScreener}
                  onShowAbout={handleShowAbout}
                />
              </motion.div>
            )}
            
            {currentScreen === 'screener' && (
              <motion.div
                key="screener"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.3 }}
              >
                <Screener 
                  answers={answers}
                  setAnswers={setAnswers}
                  onShowResults={handleShowResults}
                />
              </motion.div>
            )}
            
            {currentScreen === 'results' && (
              <motion.div
                key="results"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.3 }}
              >
                <Results 
                  phase={resultPhase}
                  onReset={handleResetScreener}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </main>
      </div>
      
      <AboutModal 
        isOpen={showAboutModal}
        onClose={handleCloseAbout}
      />
    </div>
  );
}

export default App;